// === Файл 1: wishlist-toggle.js ===
// Подключается на всех страницах с карточками товаров

document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll('.wishlist_button');

	const filledHeartSVG = `
		<svg class="heart-filled" width="35px" height="35px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M19.3 5.71002C18.841 5.24601 18.2943 4.87797 17.6917 4.62731C17.0891 4.37666 16.4426 4.2484 15.79 4.25002C15.1373 4.2484 14.4909 4.37666 13.8883 4.62731C13.2857 4.87797 12.739 5.24601 12.28 5.71002L12 6.00002L11.72 5.72001C10.7917 4.79182 9.53273 4.27037 8.22 4.27037C6.90726 4.27037 5.64829 4.79182 4.72 5.72001C3.80386 6.65466 3.29071 7.91125 3.29071 9.22002C3.29071 10.5288 3.80386 11.7854 4.72 12.72L11.49 19.51C11.6306 19.6505 11.8212 19.7294 12.02 19.7294C12.2187 19.7294 12.4094 19.6505 12.55 19.51L19.32 12.72C20.2365 11.7823 20.7479 10.5221 20.7442 9.21092C20.7405 7.89973 20.2218 6.64248 19.3 5.71002Z" fill="#000000"/>
		</svg>`;

	const emptyHeartSVG = `
		<svg width="30px" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<rect x="0" fill="none" width="24" height="24"></rect>
			<g>
				<path d="M16.5 4.5c2.206 0 4 1.794 4 4 0 4.67-5.543 8.94-8.5 11.023C9.043 17.44 3.5 13.17 3.5 8.5c0-2.206 1.794-4 4-4 1.298 0 2.522.638 3.273 1.706L12 7.953l1.227-1.746c.75-1.07 1.975-1.707 3.273-1.707m0-1.5c-1.862 0-3.505.928-4.5 2.344C11.005 3.928 9.362 3 7.5 3 4.462 3 2 5.462 2 8.5c0 5.72 6.5 10.438 10 12.85 3.5-2.412 10-7.13 10-12.85C22 5.462 19.538 3 16.5 3z"/>
			</g>
		</svg>`;

	let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

	function isInWishlist(id) {
		return wishlist.some(item => item.productId === id);
	}

	function toggleWishlist(button) {
		const data = {
			productId   : button.getAttribute('data-product-id'),
			productTitle: button.getAttribute('data-product-title'),
			productImg  : button.getAttribute('data-product-image'),
			productPrice: button.getAttribute('data-product-price'),
			productUrl  : button.getAttribute('data-product-url')
		};

		const index = wishlist.findIndex(item => item.productId === data.productId);

		if (index > -1) {
			wishlist.splice(index, 1);
			button.innerHTML = emptyHeartSVG;
		} else {
			wishlist.push(data);
			button.innerHTML = filledHeartSVG;
		}

		localStorage.setItem('wishlist', JSON.stringify(wishlist));
	}

	buttons.forEach(button => {
		const id = button.getAttribute('data-product-id');
		button.innerHTML = isInWishlist(id) ? filledHeartSVG : emptyHeartSVG;

		button.addEventListener('click', () => {
			toggleWishlist(button);
		});
	});
});


// === Файл 2: wishlist-page.js ===
// Подключается только на /wishlist

document.addEventListener('DOMContentLoaded', () => {
	if (!window.location.pathname.includes('/wishlist')) return;

	const container = document.getElementById('wishlist-items');
	if (!container) return;

	const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

	if (wishlist.length === 0) {
		container.innerHTML = '<p>הרשימה שלך ריקה כרגע 🖤</p>';
		return;
	}

	wishlist.forEach(product => {
		const item = document.createElement('div');
		item.classList.add('wishlist-product');
		item.innerHTML = `
			<a href="${product.productUrl}" class="wishlist-product-link">
				<img src="${product.productImg}" alt="${product.productTitle}" />
				<h3>${product.productTitle}</h3>
				<p>${product.productPrice}</p>
			</a>
		`;
		container.appendChild(item);
	});
});

